$(document).ready(function () {

    const slider = $('[slider]');

    if (slider.length) {
        slider.each(function () {
            var $slider = $(this),
                dots = $slider.data('slider-dots') ? $slider.data('slider-dots') : false,
                elements = $slider.data('slider-elements') ? $slider.data('slider-elements') : 1,
                scroll = $slider.data('slider-scroll') ? $slider.data('slider-scroll') : 1,
                infinite = $slider.data('slider-infinite') ? $slider.data('slider-infinite') : false,
                arrows = $slider.data('slider-arrows') ? $slider.data('slider-arrows') : false,
                disable = $slider.data('slider-disable') ? $slider.data('slider-disable') : false,
                breakpoints = $slider.data('slider-breakpoints') ? $slider.data('slider-breakpoints').toString() : false,
                activate = $slider.data('slider-activate') ? parseInt($slider.data('slider-activate')) : false,
                autoplay = $slider.data('slider-autoplay') ? parseInt($slider.data('slider-autoplay')) : false,
                dotsClass = $slider.data('slider-dots-class') ? (' ' + $slider.data('slider-dots-class')) : '',
                arrowClass = $slider.data('slider-arrows-class') ? $slider.data('slider-arrows-class') : '',
                destroy = $slider.data('slider-destroy') ? parseInt($slider.data('slider-destroy')) : false,
                asNav = $slider.data('slider-nav') ? $slider.data('slider-nav') : false,
                centerMode = $slider.data('slider-centermode') ? $slider.data('slider-centermode') : false,
                initialSlide = $slider.data('slider-initial') ? parseInt($slider.data('slider-initial')) : false,
                vertical = $slider.data('slider-vertical') ? $slider.data('slider-vertical') : false,
                enable = $slider.data('slider-enable') ? $slider.data('slider-enable') : false,
                responsive = {
                    slidesToShow: elements,
                    slidesToScroll: scroll,
                },
                settings;
            $slider
                .removeAttr('data-slider-dots')
                .removeAttr('data-slider-elements')
                .removeAttr('data-slider-scroll')
                .removeAttr('data-slider-infinite')
                .removeAttr('data-slider-arrows')
                .removeAttr('data-slider-arrows-class')
                .removeAttr('data-slider-disable')
                .removeAttr('data-slider-breakpoints')
                .removeAttr('data-slider-activate')
                .removeAttr('data-slider-dots-class')
                .removeAttr('data-slider-autoplay')
                .removeAttr('data-slider-destroy')
                .removeAttr('data-slider-nav')
                .removeAttr('data-slider-centermode')
                .removeAttr('data-slider-initial')
                .removeAttr('data-slider-vertical')
                .removeAttr('data-slider-enable');

            if (activate && activate < $(window).width()) return;

            disable = disable ? checkDisable(disable) : {};
            autoplay = autoplay ? getAutoplay(autoplay) : {};

            if (breakpoints) {
                responsive = {
                    responsive: getResponsiveOptions(elements, breakpoints)
                };
            }

            if (elements === 'auto') {
                responsive = Object.assign({}, responsive, {variableWidth: true});
                delete responsive.slidesToShow;
            }
            if (asNav)
                responsive = Object.assign({}, responsive, {asNavFor: asNav});
            if (centerMode)
                responsive = Object.assign({}, responsive, {centerMode: true, centerPadding: centerMode});
            if (initialSlide)
                responsive = Object.assign({}, responsive, {initialSlide: initialSlide});
            if (vertical)
                responsive = Object.assign({}, responsive, {vertical: true, verticalSwiping: true});

            settings = Object.assign({}, Object.assign({}, disable, autoplay), responsive);

            if (enable) {
                const options = enable.split('|');
                for (const option of options) {
                    settings = enableOption(settings, option);
                }
            }

            const options = Object.assign({
                slidesToShow: elements,
                slidesToScroll: scroll,
                dots: dots,
                arrows: arrows,
                infinite: infinite,
                dotsClass: 'slick-dots' + dotsClass,
                prevArrow: '<div class="slick__arrow slick__arrow-prev ' + arrowClass + '">' +
                    '<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"' +
                    ' viewBox="0 0 59.414 59.414" xml:space="preserve" fill="#333">' +
                    '<g>' +
                    '<polygon points="43.854,59.414 14.146,29.707 43.854,0 45.268,1.414 16.975,29.707 45.268,58 "/>' +
                    '</g>' +
                    '</svg>' +
                    '</div>',
                nextArrow: '<div class="slick__arrow slick__arrow-next ' + arrowClass + '">' +
                    '<svg xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"' +
                    ' viewBox="0 0 59.414 59.414" fill="#333">' +
                    '<g>' +
                    '<polygon points="15.561,59.414 14.146,58 42.439,29.707 14.146,1.414 15.561,0 45.268,29.707 "/>' +
                    '</g>' +
                    '</svg>' +
                    '</div>',
            }, settings);

            if (centerMode) {
                delete options.slidesToShow;
            }

            if (destroy) {
                if ($(window).width() > destroy) {
                    $slider.slick(options);
                }

                $slider.addClass('initialized');

                bindResize($slider, options, destroy);
            } else {
                $slider.slick(options);
            }
        });
    }

    function checkDisable(disable) {
        if (disable === "all") {
            return disableAll(disable);
        } else {
            return disableEvent(disable);
        }
    }

    function enableOption(options, option) {
        return Object.assign(options,
            {
                [option]: true
            }
        );
    }

    function disableAll() {
        return {
            accessibility: false,
            autoplay: false,
            draggable: false,
            swipe: false,
            swipeToSlide: false,
            touchMove: false,
            dotsClass: 'slick-dots slick-dots_disabled'
        };
    }

    function getResponsiveOptions(elements, breakpoints) {
        let responsive = [];
        let breakpointsArr = (breakpoints.indexOf('|') === -1) ? [breakpoints] : breakpoints.split('|');

        for (const i in breakpointsArr) {
            if (breakpointsArr.hasOwnProperty(i)) {
                if (elements < 1) return responsive;
                responsive = [...responsive, {
                    breakpoint: breakpointsArr[i],
                    settings: {
                        slidesToShow: --elements
                    }
                }];
            }
        }

        return responsive;
    }

    function disableEvent(event) {
        return {
            [event]: false
        };
    }

    function getAutoplay(autoplay) {
        return {
            autoplay: true,
            autoplaySpeed: autoplay,
            pauseOnHover: false
        };
    }

    let timeouts = [];
    let idx = 0;

    function bindResize(slider, options, targetWidth) {
        $(window).on('resize', function () {
            if ($(window).width() > targetWidth) {
                if (slider.hasClass('slick-initialized') === false) {
                    clearTimeout(timeouts[idx]);
                    timeouts[idx] = setTimeout(() => slider.slick(options), 25);
                }
            } else if (slider.hasClass('slick-initialized')) {
                clearTimeout(timeouts[idx]);
                timeouts[idx] = setTimeout(() => slider.slick('destroy'), 25);
            }
        });
        idx++;
    }

});
